/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type FilterCategoryConfigColumn = (typeof FilterCategoryConfigColumn)[keyof typeof FilterCategoryConfigColumn];

export const FilterCategoryConfigColumn = {
  category: 'category',
} as const;
